<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CreateUrun from "./create_urun.vue";

export default {
  page: {
    title: "Ürün Yönetimi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    CreateUrun,
  },
  data() {
    return { 
            list: {},
            title: "ÜRÜN YÖNETİMİ",
            items: [
            {
                text: "ANASAYFA",
                href: "/",
            },
            {
                text: "ÜRÜN YÖNETİMİ",
                active: true,
            },
            ],
            isLoading: false,
            rows: [],
            totalRecords: 0,
            serverParams: {
            columnFilters: {},
            sort: [
                {
                field: '',
                type: '',
                },
            ],
            page: 1,
            perPage: 50,
            },
            currentPage: 0,
            pageLength: 0,
            url: "/stock/product",
            paginationOptions: {
            enabled: true,
            dropdownAllowAll: false,
            perPage: 50,
            setCurrentPage: 1,
            perPageDropdown: [50, 100, 200],
            nextLabel: 'Sonraki',
            prevLabel: 'Önceki',
            rowsPerPageLabel: 'Kayıt Göster',
            ofLabel: 'of',
            pageLabel: 'sayfa', // for 'pages' mode
            infoFn: params => `Bulunduğun Sayfa ${params.currentPage}`,
            },
            selectOptions: {
                enabled: false,
                selectOnCheckboxOnly: false,
                selectionInfoClass: 'custom-class',
                selectionText: 'adet kayıt seçildi',
                clearSelectionText: 'seçimi iptal et',
                disableSelectInfo: false,
                selectAllByGroup: false,
            },
            columns: [
                {
                    field: '#',
                    sortable: false,
                    thClass: 'width-50',
                },
                {
                    label: 'Grup',
                    field: this.group_id,
                    sortable: false,
                },
                {
                    label: 'Ürün Hizmeti',
                    field: 'name',
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [],
                    },
                },
                {
                    label: 'Satış Fiyatı',
                    field: 'price',
                    sortable: false,
                },  
                {
                    label: 'Birim',
                    field: 'unit',
                    sortable: false,
                },
            ],
            openModal:0
        };
    },
    mounted() {
        this.loadItems()
     },
    methods: {
        group_id(rowObj) {
            const data = {
                "an" : "Anten",
                "ka" : "Kablo",
                "mo" : "Modem",
                "sm" : "Sarf Malzeme",
            }
            return  data[rowObj.group_id]
        },
        updateParams(newProps) {
            this.serverParams = { ...this.serverParams, ...newProps }
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage })
            this.loadItems()
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage })
            this.loadItems()
        },
        onSortChange(params) {
            this.updateParams({ sort: params})
            this.loadItems()
        },
        onColumnFilter(params) {
            this.updateParams(params)
            this.loadItems()
        },
        loadItems() {
            this.getFromServer(this.serverParams).then(response => {
                this.totalRecords = response.totalRecords
                this.pageLength = response.pageLength
                this.currentPage = response.currentPage
                this.rows = response.rows
            })
        },
        getFromServer() {
            return new Promise((resolve, reject) => {
                this.$http.post(this.url, this.serverParams)
                .then(res => {
                    resolve({
                    rows: res.data.data,
                    totalRecords: res.data.total,
                    pageLength: res.data.last_page,
                    currentPage: res.data.current_page,
                    })
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        onSearch(params) {
            this.updateParams(params)
            this.loadItems()
        },
        create(){
            this.openModal += 1
            this.$parent.$bvModal.show('modal-urun')
        },
        update(props, type){
            this.openModal += 1
            this.list = { ...props, type}
            this.$parent.$bvModal.show('modal-urun')
        },
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <CreateUrun 
        :list="list" 
        @loadItems="loadItems"
    />

    <div class="row">     
        <div class="col-12">
            <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{
                    enabled: false,
                    placeholder: 'Arama İçin Enter\'a Basınız'
                  }"
                @on-search="onSearch"
                :select-options="selectOptions"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
                <div slot="table-actions">
                    <button 
                    class="btn btn-success btn-sm" 
                    style="margin-right:10px;margin-top:2px" 
                    type="button" 
                    @click="create()"
                    >Yeni Oluştur
                    </button>
                </div>
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <b-dropdown
                    v-if="props.column.field === '#'"
                    class="ms-2 "
                    toggle-class="font-size-16 p-0"
                    toggle-tag="a"
                    variant="white"
                    right
                >
                    <template #button-content>
                      <i class="mdi mdi-dots-horizontal"></i>
                    </template>
                    <template>
                        <b-dropdown-item @click="update(props.row,'update')">Düzenle</b-dropdown-item>
                    </template>
                  </b-dropdown>
                </template>
            </vue-good-table>
        </div>
    </div>
  </Layout>
</template>
